// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.bank-item[data-v-ae09c0ee] {\r\n    border-radius: 0;\n}\n.bg-tint-light[data-v-ae09c0ee] {\r\n  background-color: rgba(255, 255, 255, 0.1);\n}\n.bg-tint-dark[data-v-ae09c0ee] {\r\n  background-color: rgba(0, 0, 0, 0.3);\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
